import * as React from 'react'

interface Props {
  text: string
  currentOperation?: string
}

export default class PageTitle extends React.Component<Props, {}> {
  constructor(props: any) {
    super(props)
  }

  render() {
    return (
      <div className="page-title">
        <span className="page-title-text">{this.props.text}</span>
        <span className="page-title-operation">{this.props.currentOperation}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageTitle.tsx